export const en = {
  languageBtn: "ع",
  deleteAccount: "Delete Account",
  deleteConfirmMsg:
    "Once your account is deleted, all your data will be permanently deleted and cannot be recovered",
  iAgree: "I Agree",
  enterPhoneNumber:
    "To delete your account, enter your phone number to receive an SMS for verification",
  phoneRequired: "Phone number is required",
  phoneInvalid: "Please enter a valid phone number",
  confirm: "Confirm",
  enterVerificationCode: "Enter verification code",
  verificationCodeRequired: "Verification code is required",
  verificationCodeInvalid: "Verification code must contain digits only",
  accountDeleted: "Your account has been deleted",
};
